// extracted by mini-css-extract-plugin
module.exports = {"editButton":"u0"};